import * as types from './action-types'

export const fetchIndustries = employerId => ({
  type: types.INDUSTRIES_FETCH_BEGIN,
  employerId,
})
